import React, {useState, useEffect} from "react";
import {useTitleFromComponent, useDataWithRoute, useUrlState} from "../../../utils/hooks";
import {useVsiAppContext} from "../../../stores/VsiApp";
import {VsiBubble, VsiH4} from "../../../styled/App.styled";
import {Button, ButtonGroup, Card, Spinner} from "reactstrap";
import {VsiSelectLabel} from "../../../styled/VsiLabeledSelect.styled";
import themeStyles from "../../../utils/themeStyles";
import {snakeCaseToTitleCase} from "../../../utils/Helpers";
import StackedColumnChart from "../../../components/StackedColumnChart";

const cloudStorageSortingArr = ['Savings'];
const computeSortingArr = ['CPU Savings', 'Memory Savings', 'Orphaned VMDK Cost'];
const totalSortingArr = ['Total Savings'];

export default function SavingsReport({context: reportContext, title}) {
    useTitleFromComponent(`${reportContext} / ${title}`);
    const {theme, client, periodId} = useVsiAppContext();

    const [params, setParams] = useUrlState({context: "total", value_type: 'cost'});
    const [routeParameter, setRouteParameter] = useState(params.context || 'total')

    const {context} = params;

    const [data, isLoading] = useDataWithRoute(`/api/v6/report/executive_savings_proc?client_id=${client.clientId}&period_id=${periodId}&report_option=${routeParameter}`);
    const [valueType, setValueType] = useState('cost');
    const [tagCats, setTagCats] = useState([]);
    const [graphData, setGraphData] = useState([]);

    const barChartBuilder = (passedData) => {
        let tags = passedData.map(datum => {
            if (context !== 'cloud') {
                return snakeCaseToTitleCase(datum.legend || '');
            } else {
                return ''
            }
        });
        let finalArray = [];
        let sortingArr = [];

        if (['storage', 'cloud'].indexOf(context) > -1) {
            let savingsNewData = passedData?.map(datum => datum['potential_savings' + (valueType === 'gib' ? '_gib' : '')]);
            finalArray = [savingsNewData];
            sortingArr = cloudStorageSortingArr;
        }
        if (context === 'compute') {
            let cpuSavings = passedData?.map(datum => datum.cpu_savings);
            let memorySavings = passedData?.map(datum => datum.memory_savings);
            let orphanedCost = passedData?.map(datum => datum.orphaned_vmdk_cost);
            finalArray = [cpuSavings, memorySavings, orphanedCost];
            sortingArr = computeSortingArr;
        }
        if (context === 'total') {
            let totalSavings = passedData?.map(datum => datum['total_savings' + (valueType === 'gib' ? '_gib' : '')]);
            finalArray = [totalSavings];
            sortingArr = totalSortingArr;
        }
        let chartInfo = sortingArr.map((d, idx) => {
            return {
                name: d,
                data: finalArray[idx]
            }
        });
        setTagCats(tags);
        setGraphData(chartInfo);
    };
    useEffect(() => {
        barChartBuilder(data.recordsets[0] || []);
    }, [data, valueType]);

    const onContextChange = (value) => {
        setParams({
            context: value
        });
        setRouteParameter(value)
    };

    const onValueTypeChange = (value) => {
        setParams({
            value_type: value
        });
        setValueType(value)
    };

    return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>Savings Report</VsiH4>
            <VsiBubble>
                <VsiSelectLabel>Context</VsiSelectLabel>
                <div className="d-flex align-items-start">
                    <ButtonGroup>
                        <Button onClick={() => onContextChange("total")}
                                disabled={context === "total"}
                                active={context === "total"}>
                            Total
                        </Button>
                        <Button onClick={() => onContextChange("storage")}
                                disabled={context === "storage"}
                                active={context === "storage"}>
                            Storage
                        </Button>
                        <Button onClick={() => onContextChange("compute")}
                                disabled={context === "compute"}
                                active={context === "compute"}>
                            Compute
                        </Button>
                        <Button onClick={() => onContextChange("cloud")}
                                disabled={context === "cloud"}
                                active={context === "cloud"}>
                            Cloud
                        </Button>
                    </ButtonGroup>
                    <div style={{marginLeft: '20px'}}/>
                    {["total", "storage", "cloud"].indexOf(context) > -1 ?
                        <ButtonGroup>
                            <Button onClick={() => onValueTypeChange("cost")}
                                    disabled={valueType === "cost"}
                                    active={valueType === "cost"}>
                                $
                            </Button>
                            <Button onClick={() => onValueTypeChange("gib")}
                                    disabled={valueType === "gib"}
                                    active={valueType === "gib"}>
                                GiB
                            </Button>

                        </ButtonGroup> : ''}
                </div>
            </VsiBubble>
            <VsiBubble autobotName='ColumnChart'>
                <>{isLoading.isLoading ? <Spinner style={{color: themeStyles[theme].textColor}}/> :
                    <StackedColumnChart
                        categories={tagCats}
                        height={600}
                        yAxisTitle={valueType === 'cost' ? 'Cost ($)' : 'GiB'}
                        colors={['#099c9d', '#B0EA3B', '#ff8d02']}
                        includeLegend={true}
                        series={graphData}
                    />
                }

                </>
            </VsiBubble>
        </Card>
    )
}
